import gql from 'graphql-tag'
import DocumentsFragment from '../../documents/queries/DocumentsFragment'
import { etran } from '../../shared/fragments'

export default gql`
  query EtranQuery($rid: Int!) {
    loan(rid: $rid, unscoped: true) {
      rid
      appNumber
      business {
        rid
      }
      etranResultsDocument {
        rid
      }
      ${etran}
    }
  }
`
